import React from 'react';
import ReactApexChart from 'react-apexcharts';

const UserByCountryChart = ({ countryData = [] }) => {
  // Transform API data for chart
  const countries = countryData.map(item => item.CountryName);
  const farmerCounts = countryData.map(item => item.FarmerCount);

  const doughnutOptions = {
    chart: {
      type: 'donut',
    },
    labels: countries,
    legend: {
      position: 'right',
      horizontalAlign: 'center',
    },
    dataLabels: {
      enabled: true,
      formatter: function (val, opts) {
        return opts.w.config.series[opts.seriesIndex] + ' farmers';
      },
    },
    plotOptions: {
      pie: {
        donut: {
          size: '65%',
          labels: {
            show: true,
            total: {
              show: true,
              label: 'Total Farmers',
              formatter: function (w) {
                return w.globals.seriesTotals.reduce((a, b) => a + b, 0);
              },
            },
          },
        },
      },
    },
    colors: ['#4CAF50', '#81C784', '#A5D6A7', '#C8E6C9', '#E8F5E9'],
  };

  const doughnutSeries = farmerCounts;

  return (
    <div className="col-xxl-6 col-xl-12">
      <div className="card h-100">
        <div className="card-body">
          <h6 className="text-lg mb-0" style={{ color: '#1B5E20', fontWeight: 'bold' }}>
            Farmers By Country
          </h6>
          
          <ReactApexChart 
            options={doughnutOptions} 
            series={doughnutSeries} 
            type="donut"
            height={350} 
          />
        </div>
      </div>
    </div>
  );
};

export default UserByCountryChart;